import React, { createContext, useContext } from 'react'

type RadioGroupContextType = {
  name?: string,
  selectedValue?: string | number,
  onChange?: (value: never) => void,
}

const RadioGroupContext = createContext<RadioGroupContextType>({})

type RadioGroupProps<T extends string | number> = React.PropsWithChildren<{
  name?: string,
  selectedValue?: T,
  onChange?: (value: T) => void,
  className?: string,
}>

/** A group of native radio inputs sharing one name and value */
export const RadioGroup = <T extends string | number>(props: RadioGroupProps<T>) => {
  const { name, selectedValue, onChange, className, children } = props
  return (
    <RadioGroupContext.Provider value={{ name, selectedValue, onChange: onChange as (value: never) => void }}>
      <div className={className}>{children}</div>
    </RadioGroupContext.Provider>
  )
}

type RadioProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'name' | 'checked' | 'value'> & {
  value: string | number,
}

export const Radio: React.FC<RadioProps> = (props) => {
  const { value, ...rest } = props
  const { name, selectedValue, onChange } = useContext(RadioGroupContext)
  return (
    <input
      {...rest}
      type={'radio'}
      name={name}
      value={value}
      checked={selectedValue === value}
      onChange={() => onChange?.(value as never)}
    />
  )
}
